// Celestial Cream™ Low — UNIXORN's first luxury footwear release.
// Single product. Cinematic museum presentation. Shopify checkout.

export const celestialCreamLow = {
  id: "unixorn-celestial-cream-low",
  name: "UNIXORN Celestial Cream™ Low",
  shortName: "Celestial Cream Low",
  tagline: "The first relic. Walked forward.",
  campaign: "CELESTIAL CREAM™",
  price: 175,
  available: true,
  images: {
    main: "/assets/images/celestial/main.png",
    side: "/assets/images/celestial/side.png",
    front: "/assets/images/celestial/front.png",
    back: "/assets/images/celestial/back.png",
    inside: "/assets/images/celestial/inside.png",
    sole: "/assets/images/celestial/sole.png",
  },
  story:
    "The Celestial Cream™ Low is the inaugural UNIXORN footwear release — a sculpted low-profile silhouette in monochrome cream, marked only by the Infinity Horn emblem. Forged for daily ritual, designed to outlast season.",
  spec: [
    { label: "Construction", value: "Sculpted low-profile silhouette" },
    { label: "Upper", value: "Premium cream leather composite" },
    { label: "Emblem", value: "Infinity Horn at heel — minimal, tonal" },
    { label: "Midsole", value: "Cream-on-cream cushioned form" },
    { label: "Lining", value: "Soft warm-stone interior" },
    { label: "Drop", value: "Limited inaugural release" },
  ],
};
